/**
 * Spacing tokens from Figma design system
 *
 * Values are in pixels. Use with theme.spacing() or directly.
 * MUI base unit is set to spacing[1] (4px).
 */

export const spacing = {
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  7: 32,
  8: 40,
  9: 48,
  10: 64,
  11: 80,
  12: 96,
  13: 180,
} as const;

export type Spacing = typeof spacing;
